import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
@Component({
  selector: 'app-projectmap',
  templateUrl: './projectmap.component.html',
  styleUrls: ['./projectmap.component.scss']
})
export class ProjectmapComponent implements OnInit {
  closeguidline = false;
  toppings = new FormControl('');

  constructor() { }
  ngOnInit(): void {
  }
  closeguidlinefun() {
    this.closeguidline = !this.closeguidline;
    console.log(this.closeguidline);

  }
}
